import { isApp, getQueryString } from "@/utils/common";
import { createRouter, createWebHashHistory } from "vue-router";
import { useUserStore } from "@/store";
const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: "/",
      name: "Home",
      component: () => import("../views/home.vue"),
      meta: {
        title: "常宝666，光影过大年",
        needAuth: true,
        keepAlive: false,
      },
    },
    {
      path: "/wish",
      name: "Wish",
      component: () => import("../views/wish.vue"),
      meta: {
        title: "影评赢好礼",
        needAuth: true,
        keepAlive: false,
      },
    },
    {
      path: "/auth",
      name: "Auth",
      component: () => import("../views/auth.vue"),
      meta: {
        title: "登录",
        needAuth: false,
      },
    },

    {
      path: "/test",
      name: "Test",
      component: () => import("../views/test.vue"),
      meta: {
        title: "测试页面",
        needAuth: false,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (getQueryString("token") && to.path != "/auth") {
    next("/auth");
    return;
  }
  if (to.meta.needAuth && !useUserStore().isLogin) {
    // 此路由需要授权，请检查是否已登录
    // 如果没有，则重定向到登录页面
    useUserStore().setLandPage(to.fullPath);
    next(`/auth`);
    return;
  }
  next();
});
export default router;
